import React from 'react';
import track from './track';

interface Props {
    href: string;
    text?: string;
    className?: string;
    setRef?: React.Ref<any>;
    children?: React.ReactNode;
    // when the link is clicked the link text will be sent as the anaylics payload, dataName is sent instead if passed in
    dataName?: string;
    target?: string;
    onClick?: () => void;
}

const AtlasLink = (props: Props) => {
    const { href, text, className, children, dataName, setRef, ...rest } =
        props;

    return (
        <a
            ref={setRef}
            href={href}
            data-testid="atlas_link"
            className={className}
            onClick={() => track(href, text, dataName)}
            {...rest}
        >
            {children ? children : text}
        </a>
    );
};

export default AtlasLink;
